<!--材料预约列表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="organizationCode"
          v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
          selectType="selectAssemble"
          :selectData="inventOrg"
          :disabled="isDisableOrganization"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
          @change="inventOrgValueOnChange"
        />
        <global-select
          slot="workshopCode"
          :value.sync="queryParams.workshopCode"
          :selectData="workshopList"
          selectType="selectFilter"
          :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <create-modal ref="createModalRef" @refresh="handleOk" />
        <a-button v-hasPermi="['bom:bomWorkCenterCc:save']" type="primary" :loading="loading" @click="onCreate">新增</a-button>
        <a-button v-hasPermi="['bom:bomWorkCenterCc:remove']" :loading="loading" @click="onDelete">删除</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          :pagination="false"
          :expandedRowKeys.sync="expandedRowKeys"
          @selectedRowChange="selectedRowChange"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
          <!-- 工作中心 -->
          <template slot="centerName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.centerName" placeholder="请输入" :maxLength="40" />
          </template>
          <!-- 工作中心类别 -->
          <template slot="centerCategoryName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              v-model="record.centerCategory"
              :selectData="workCenterTypeList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
            />
          </template>
          <!-- 供应子库名称 -->
          <template slot="supplySublibraryName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              searchParam="supplySublibrary"
              selectType="selectAssembleSearch"
              :value.sync="record.supplySublibrary"
              requestApi="/inv/invCallRequestLines/intoSublibraryBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ 'organizationCode': record.organizationCode }"
            />
          </template>
          <!-- 完工子库名称 -->
          <template slot="completedSublibraryName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              searchParam="completedSublibrary"
              selectType="selectAssembleSearch"
              :value.sync="record.completedSublibrary"
              requestApi="/inv/invCallRequestLines/intoSublibraryBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ 'organizationCode': record.organizationCode }"
              @change="(val, selectList) => handleCompletedSublibraryChange(val, record)"
            />
          </template>
          <!-- 完工货位 -->
          <template slot="completedLocation" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              searchParam="locationCode"
              selectType="selectSearch"
              :value.sync="record.completedLocation"
              requestApi="/inv/invCallRequestLines/intoGoodsAllocationBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ 'subinventoryCode': record.completedSublibrary }"
            />
          </template>
          <!-- 备注 -->
          <template slot="remark" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.remark" placeholder="请输入" :maxLength="100" />
          </template>
          <span slot="operation" slot-scope="text">
            <a
              v-if="(!isEdit || currentId !== text.record.id)"
              v-hasPermi="['bom:bomWorkCenterCc:save']"
              @click="handleEdit(text.record)"
            >编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
// import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'

import {
  // apiWorkCenterList,
  apiWorkCenterTreeList,
  apiWorkCenterUpdate,
  apiWorkCenterDel,
  apiWorkCenterExport
 } from '@/api/mes/productionPrepare/workCenter'
import { apiBomWorkshopFindList } from '@/api/mes/productionPrepare/attributeMaintenance'
import createModal from './components/create-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

import { mapState } from 'vuex'
import moment from 'moment';

export default {
  name: 'WorkCenter',
  components: { DownloadModal, createModal, ImportExcel },
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  data() {
    return {
      apiWorkCenterExport,
      loading: false, // 请求loading
      isEdit: false,
      currentId: '',
      selectedRowKeys: [],
      selectedRows: [],
      expandedRowKeys: [],
      // 表格配置
      tableProps: {
        requestApi: this.generateLsTableResData(apiWorkCenterTreeList),
        pageCurrent: true
      },
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomWorkCenterCc/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'bom/bomWorkCenterCc/template',
        name: `工作中心导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      workshopList: [], // 车间列表
      workCenterTypeList: [], // 工作中心类别
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        workshopCode: undefined,
        centerCode: undefined,
        centerName: undefined
      },
      formList: [
        { label: '组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '车间', decorator: ['workshopCode'], type: 'workshopCode' },
        { label: '工作中心编码', decorator: ['centerCode'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '工作中心名称', decorator: ['centerName'], type: 'input', attrs: { placeholder: '请输入' } }],
      // 表格字段
      columns: [
        { title: '工作中心编码', dataIndex: 'centerCode', align: 'left', width: 240 },
        { title: '工作中心名称', dataIndex: 'centerName', scopedSlots: { customRender: 'centerName' }, align: 'center', width: 140 },
        { title: '工作中心类别', dataIndex: 'centerCategoryName', scopedSlots: { customRender: 'centerCategoryName' }, align: 'center', width: 240 },
        { title: '所属加工组织', dataIndex: 'organizationName', align: 'center', width: 200 },
        { title: '所属车间', dataIndex: 'workshopDesc', align: 'center', width: 140 },
        { title: '供应子库', dataIndex: 'supplySublibraryName', scopedSlots: { customRender: 'supplySublibraryName' }, align: 'center', width: 240 },
        { title: '完工子库', dataIndex: 'completedSublibraryName', scopedSlots: { customRender: 'completedSublibraryName' }, align: 'center', width: 240 },
        { title: '完工库位', dataIndex: 'completedLocation', scopedSlots: { customRender: 'completedLocation' }, align: 'center', width: 240 },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, align: 'center', width: 140 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    apiBomWorkshopFindList({
      workshopStatus: "Y",
      organizationCode: this.organizationCodeOrigin
    }).then(res => {
      if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
    });
    this.queryParams.organizationCode = this.organizationCodeOrigin;
    this.cacheLookupRequest('WORK_CENTER_TYPE', { lookupType: 'WORK_CENTER_TYPE', current: 1, pageSize: 999 }, 'workCenterTypeList')
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    moment,
    // 加工组织
    inventOrgValueOnChange (val, status) {
      this.queryParams.workshopCode = '';
      apiBomWorkshopFindList({ organizationCode: val, workshopStatus: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
      })
    },
    // 子库变化
    handleCompletedSublibraryChange(val, record) {
      record.completedLocation = ''; // 变化完工子库时，清空完工库位
    },
    // 行选中
    selectedRowChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.id
    },
    // 保存
    handleSave(record) {
      if (!record?.centerCode) {
        this.$message.warning('请输入工作中心编码')
        return
      }
      if (!record?.centerName) {
        this.$message.warning('请输入工作中心名称')
        return
      }
      if (!record?.centerCategory) {
        this.$message.warning('请输入工作中心类别')
        return
      }
      if (!record?.workshopCode) {
        this.$message.warning('请输入所属车间')
        return
      }
      this.loading = true

      apiWorkCenterUpdate(record)
        .then((res) => {
          if (res?.code === 200) {
            this.$message.success('编辑成功')
            this.handleOk(true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false
      this.currentId = ''
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: this.organizationCodeOrigin,
        workshopCode: undefined,
        centerCode: undefined,
        enable: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 新增物料
    onCreate() {
      this.$refs.createModalRef.show()
    },
    // 删除
    onDelete() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: '请确认是否删除勾选单据？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          const codes = self.selectedRows.map(item => item.centerCode)
          apiWorkCenterDel(codes).then(res => {
            if (res?.code === 200) {
              self.$message.success(res?.msg || '操作成功')
              self.handleOk()
            }
          }).finally(() => {
            self.loading = false;
          })
        }
      })
    },
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    generateLsTableResData (request) {
      return params => {
        return new Promise((resolve, reject) => {
          params.pageNum = params.page;
          delete params.page;
          request(params).then(res => {
            const { pageSize } = params
            const pages = Math.ceil(res.length / pageSize)
            this.expandedRowKeys.splice(0, this.expandedRowKeys.length)
            this.getExpandedRowKeys(res)
            resolve({
              data: {
                state: 100,
                data: {
                  records: res,
                  pages,
                  total: res.length
                }
              }
            })
          }).catch(err => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              msg: err,
              state: 103
            })
          })
        })
      }
    },
    getExpandedRowKeys(treeList) {
      const self = this;
      if (Array.isArray(treeList) && treeList.length > 0) {
        treeList.forEach(item => {
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.expandedRowKeys.push(item.id);
            self.getExpandedRowKeys(item.children);
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.pub-select {
  /deep/ .ant-select {
    width: 100%;
  }
}
</style>
